import './components.css';

import { CommitColumn } from './CommitColumn';

import { commitprops, workflowgroups } from '../state/store';
import { WorkflowGroup } from './WorkflowGroup';

export function Table() {

  return (
    <div class="luci-table">
      <CommitColumn commits={commitprops.value}></CommitColumn>
      {workflowgroups.value.map(
        p => <WorkflowGroup {...p} key={p.fullname} />)}
    </div>
  );
}
